import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';

const NavigationItemLabel = ({ hasChannelName, children }) => {
  const className = classnames('nav__label', {
    'nav__label--channel': hasChannelName,
  });

  return <span className={className}>{children}</span>;
};

NavigationItemLabel.propTypes = {
  hasChannelName: PropTypes.bool,
  children: PropTypes.string.isRequired,
};

export default React.memo(NavigationItemLabel);
